import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../Services/auth.service';
import UserService from '../../Services/user.service';
import backIcon from '../../assests/images/left-arrow.png';
import Lottie from "lottie-react";
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import forgetPasswordAnimation from '../../assests/images/Animations/forgetPassword.json';
import pageCoverImage from '../../assests/images/login/cover1.svg';
import loginBrandCoverSystemStillWash from '../../assests/branding/xtram/graphics/login-brand-cover-system-still-wash.svg';
import loginBrandCoverSystemStillBrand from '../../assests/branding/xtram/graphics/login-brand-cover-system-still-brand.svg';
import logoImage from '../../assests/images/login/logo-blue.svg';
import BrandXMark from '../../Components/Widgets/BrandXMark/BrandXMark';
import { ToastContainer, toast } from "react-toastify";
import { LanguageSelector } from '../../Components/Login/SubComponents/LanguageSelector';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import VerifyOtpComponent from '../../Components/Login/SubComponents/VerifyOtp';
import ResetPassword from '../../Components/Login/SubComponents/ResetPassword';
import PasswordChanged from '../../Components/Login/SubComponents/PasswordChanged';
import Constants from '../../assests/Constants/constants';
import ClientCreatedSuccessModal from '../../Components/Widgets/ClientRegisterModal/ClientCreatedSuccessModal';
import ClientRegisterModal from '../../Components/Widgets/ClientRegisterModal/ClientRegisterModal';
import { PermissionsContext } from '../../Contexts/Permissions';
import Styles from './Login.module.scss';

const Login = () => {
  const [accountantId, setAccountantId] = useState('');
  const [userName, setUserName] = useState(localStorage.getItem('userName') || '');
  const [password, setPassword] = useState('');
  const [reEnterPassword, setReEnterPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [forgetPassword, setForgetPassword] = useState(localStorage.getItem('forgetPassword') === 'true');
  const [verifyOtp, setVerifyOtp] = useState(localStorage.getItem('verifyOtp') === 'true');
  const [resetPassword, setResetPassword] = useState(localStorage.getItem('resetPassword') === 'true');
  const navigate = useNavigate();
  const { refreshPermissions } = useContext(PermissionsContext);
  const { t, i18n } = useTranslation();
  const direction = i18n.dir();
  const [showPassword, setShowPassword] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'he');
  const [passwordDialogVisible, setPasswordDialogVisible] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState(2);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [addClientModalVisible, setAddClientModalVisible] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const loginSuccessTimerRef = useRef(null);

  const handleUserTypeChange = (event, newUserType) => {
    if (newUserType !== null) {
      setSelectedUserType(newUserType);
    }
  };
  const handleOpenDialog = () => {
    setPasswordDialogVisible(true);
  };

  const handleCloseDialog = () => {
    setPasswordDialogVisible(false);
  };

  const closeCreatedSuccessModalModal = () => {
    setShowSuccessModal(false);
  };
  const mainPage = (!forgetPassword && !verifyOtp && !resetPassword);
  const handleContactUsPress = () => {
    const phoneNumber = '972535781181'; // Replace with the actual phone number
    const message = t('helloHelpRequest'); // Replace with the actual template message
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`; // Changed URL to fit WhatsApp Web format

    window.open(url, '_blank').focus(); // Open the WhatsApp link in a new tab
  };
  useEffect(() => {
    // Check for saved language in localStorage
    const currentLanguage = localStorage.getItem('language') || 'he'; // Default to 'en' if no language is stored

    i18n.changeLanguage(currentLanguage);
    // initChatConf();
  }, []);

  useEffect(() => {
    setSelectedLanguage(i18n.language);
  }, [i18n.language]);


  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = await UserService.getCurrentUser();
        const token = await UserService.getCurrentToken();
        const UserType = await UserService.getCurrentUserType();
        if (user && token) {
          if (UserType.toString() === Constants.UserType.Client) {

            navigate('/client-details', { state: { client: user,  replace: true } });
          } else {
            navigate('/Main');
          }
        }

      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [navigate]);

  useEffect(() => {
    return () => {
      if (loginSuccessTimerRef.current) {
        window.clearTimeout(loginSuccessTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('forgetPassword', forgetPassword.toString());
    localStorage.setItem('verifyOtp', verifyOtp.toString());
    localStorage.setItem('resetPassword', resetPassword.toString());
    localStorage.setItem('userName', userName);
  }, [forgetPassword, verifyOtp, resetPassword, userName]);

  const handleInputChange = (setter) => (event) => {
    setter(event.target.value);
    setErrorMessage('');
  };

  const handleSetForget = () => {
    setForgetPassword(true);
    setPassword('');
    setErrorMessage('');
  };

  const handleOpenModal = () => {
    setAddClientModalVisible(true);
  };

  const handleCloseModal = () => {
    setAddClientModalVisible(false);
  };

  const handleClientSuccess = () => {
    setAddClientModalVisible(false);
    setShowSuccessModal(true);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    if (accountantId.trim() && password.trim()) {
      try {
        const response = await AuthService.login(accountantId, password, selectedUserType);

        // Check the selected user type and navigate accordingly
        setVerifyOtp(false);
        setForgetPassword(false);
        setResetPassword(false);

        // Reload PermissionsContext from the new session so Main never keeps the previous accountant
        if (refreshPermissions) {
          await refreshPermissions({ redirectIfUnauthenticated: false });
        }

        if (selectedUserType === 1) {

          navigate('/client-details', { state: { client: response.user,  replace: true } });
        } else {
          const reduceMotion =
            typeof window !== 'undefined' &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (reduceMotion) {
            sessionStorage.setItem('xtramFromLogin', '1');
            navigate('/Main', { state: { fromLogin: true } });
          } else {
            setLoginSuccess(true);
            if (loginSuccessTimerRef.current) {
              window.clearTimeout(loginSuccessTimerRef.current);
            }
            loginSuccessTimerRef.current = window.setTimeout(() => {
              sessionStorage.setItem('xtramFromLogin', '1');
              navigate('/Main', { state: { fromLogin: true } });
            }, 920);
          }
        }
      } catch (error) {
        const serverMessage =
          (typeof error === 'string' && error) ||
          error?.message ||
          error?.response?.data?.message;
        const displayMessage = serverMessage || t('errorMessage');
        toast.error(displayMessage);
        setErrorMessage(displayMessage);
      }
    } else {
      toast.error(t('Accountant ID or password cannot be empty!'));
      setErrorMessage(t('Accountant ID or password cannot be empty!'));
    }
  };

  const handleVerifyOtp = async (event) => {
    event.preventDefault();
    if (otp.trim()) {
      try {
        await AuthService.verifyOtp(userName, otp, selectedUserType);
        setVerifyOtp(false);
        setForgetPassword(false);
        setOtp('');
        setErrorMessage('');
        setResetPassword(true);
      } catch (error) {
        const displayMessage = error?.message || t('Invalid OTP. Please try again.');
        setErrorMessage(displayMessage);
        toast.error(displayMessage);
      }
    } else {
      setErrorMessage(t('Otp cannot be empty!'));
      toast.error(t('Otp cannot be empty!'));
    }
  };

  const handleResetPassword = async (event) => {
    event.preventDefault();
    if (password === reEnterPassword) {
      try {
        // Here, send the new password along with the accountantId to update the password in the backend
        const response = await AuthService.resetPassword(userName, password, selectedUserType);
        if (response.ok) {
          setResetPassword(false);
          setUserName("");
          handleOpenDialog()
          // navigate('/Login'); // Redirect to the login page or wherever appropriate
          // toast.success(t('Password changed successfully'));
        }
        else {
          setErrorMessage(t('Failed to reset password. Please try again.'));
          toast.error(t('Failed to reset password. Please try again.'));
        }

      } catch (error) {
        setErrorMessage(t('Failed to reset password. Please try again.'));
        toast.error(t('Failed to reset password. Please try again.'));
      }
    } else {
      setErrorMessage(t('Passwords do not match.'));
      toast.error(t('Passwords do not match.'));
    }

    setPassword("");
    setReEnterPassword('');
  };
  const handleGoBack = () => {
    // Navigate back to the previous page using React Router
    if (forgetPassword) {
      setForgetPassword(false);
      setUserName('');
    }
    else if (verifyOtp) {
      setVerifyOtp(false);
      setOtp('');
      setForgetPassword(true);
    }
    else if (resetPassword) {
      setVerifyOtp(false);
      setResetPassword(false);
      setForgetPassword(true);
      setOtp('');
    }
    setErrorMessage("")
  };
  const handleSendOtp = async (event) => {
    event.preventDefault();  // Prevent default form submission
    if (userName.trim()) {
      try {
        await AuthService.sendOtp(userName, selectedUserType);
        setErrorMessage('');
        setVerifyOtp(true);  // Move to verify OTP stage
        setForgetPassword(false);
        setOtp('');
        toast.success(t('Code sent'));

      } catch (error) {
        const displayMessage = error?.message || t('Failed to send OTP. Please check your accountant ID.');
        setErrorMessage(displayMessage);
        toast.error(displayMessage);
      }
    } else {
      const emptyMessage = t('Accountant ID cannot be empty!');
      setErrorMessage(emptyMessage);
      toast.error(emptyMessage);
    }
  };
  const isRTL = selectedLanguage !== 'en';
  return (
    <div className={Styles['login-container']} dir={direction === 'ltr' ? 'ltr' : 'rtl'}>
      <div className={Styles['login-bg']} aria-hidden="true">
        <img src={pageCoverImage} alt="" className={Styles['login-bg-cover']} />
        <div className={Styles['login-bg-overlay']} />
      </div>

      <div className={Styles['login-shell']}>
        <div className={Styles['login-brand-panel']}>
          <div className={Styles['login-brand-scene']} aria-hidden="true">
            <img src={loginBrandCoverSystemStillWash} alt="" className={Styles['login-brand-cover']} />
          <div className={Styles['login-brand-wash']} />
          </div>
          <BrandXMark
            className={Styles['login-brand-x']}
            armClassNames={{
              tl: `${Styles['login-brand-x-arm']} ${Styles['login-brand-x-arm-tl']}`,
              tr: `${Styles['login-brand-x-arm']} ${Styles['login-brand-x-arm-tr']}`,
              bl: `${Styles['login-brand-x-arm']} ${Styles['login-brand-x-arm-bl']}`,
              br: `${Styles['login-brand-x-arm']} ${Styles['login-brand-x-arm-br']}`,
            }}
          />
          <img
            src={logoImage}
            alt="Xtram"
            className={`${Styles['login-brand-corner-logo']} ${direction === 'ltr' ? Styles['logo-rtl'] : Styles['logo-ltr']}`}
          />
        </div>

        <div className={Styles['login-form-container']}>
          <div className={Styles['login-form-subContainer']}>
            {
              !mainPage &&
              <div className={Styles.backIconBackground} onClick={handleGoBack}>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M20 21.1667L14.8267 15.9933L20 10.82C20.52 10.3 20.52 9.45999 20 8.93999C19.48 8.41999 18.64 8.41999 18.12 8.93999L12 15.06C11.48 15.58 11.48 16.42 12 16.94L18.12 23.06C18.64 23.58 19.48 23.58 20 23.06C20.5067 22.54 20.52 21.6867 20 21.1667Z" fill="black" fillOpacity="0.9" />
                </svg>
              </div>
            }
            {
              mainPage &&
              <>
                <div className={Styles['login-form-header']}>
                  <LanguageSelector onChange={setSelectedLanguage} />
                  {/* <img src={getXtramLogo('light')} alt="Xtram" className={Styles['login-form-brand-logo']} /> */}
                </div>

                <div className={Styles['login-welcome-block']}>
                  <div className={Styles['login-welcome-title']}>
                    {t("WelcomeBack")}
                  </div>
                  <div className={Styles['login-welcome-subtitle']}>
                    {t("XtramTagline")}
                  </div>
                </div>
                <div className={Styles['toggle-button-group']}>
                  <ToggleButtonGroup
                    value={selectedUserType}
                    exclusive
                    onChange={handleUserTypeChange}
                    aria-label="User Type"
                    className={Styles['user-type-toggle']}
                  >
                    <ToggleButton value={2} aria-label={t('LogAsAccountant')}>
                      {t('LogAsAccountant')}
                    </ToggleButton>
                    <ToggleButton value={1} aria-label={t('LogAsBusiness')}>
                      {t('LogAsBusiness')}
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </>
            }
          {
            forgetPassword &&
            <>
              <div className={Styles['login-lottie-wrap']}>
                <Lottie
                  animationData={forgetPasswordAnimation}
                  loop={true}
                  style={{ width: '100%', height: 'auto' }}
                />
              </div>
              <div className={Styles['login-step-title']}>
                {t("Forget Password")}
              </div>
              <div className={Styles['login-step-subtitle']}>
                {t("EnterFileNumber")}
              </div>

              <div className={Styles['login-input-container']}>
                <div className={Styles['login-input-label']}>
                  {selectedUserType === 2 ? t('enterAccountantID') : t('enterCaseID')}
                </div>
                <TextField
                  fullWidth
                  placeholder={selectedUserType === 2 ? t('enterAccountantID') : t('enterCaseID')}
                  className={Styles['style-input']}
                  value={userName}
                  onChange={handleInputChange(setUserName)}
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                    className: `custom-input-box-sizing-toggle ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                  }}
                />
              </div>
              <button className={Styles['login-button']} onClick={handleSendOtp}>{t('send code')}</button>
              {errorMessage ? <div className={Styles['error-message']}>{errorMessage}</div> : null}
            </>
          }

          {

            verifyOtp &&
            <VerifyOtpComponent t={t} isRTL={isRTL} handleVerifyOtp={handleVerifyOtp} handleSendOtp={handleSendOtp} setOtp={setOtp} errorMessage={errorMessage} setErrorMessage={setErrorMessage} />
          }
          {
            resetPassword &&
            <ResetPassword t={t} isRTL={isRTL} password={password} setPassword={setPassword} reEnterPassword={reEnterPassword} setReEnterPassword={setReEnterPassword} handleResetPassword={handleResetPassword} handleInputChange={handleInputChange} />
          }

          <form className={Styles['login-form']} onSubmit={(forgetPassword ? handleSendOtp : verifyOtp ? handleVerifyOtp : (resetPassword ? handleResetPassword : handleLogin))}>
            {mainPage &&
              <>
                <div className={Styles['login-input-container']}>
                  <div className={Styles['login-input-label']}>
                    {selectedUserType === 2 ? t('enterAccountantID') : t('enterCaseID')}
                  </div>
                  <TextField
                    fullWidth
                    placeholder={selectedUserType === 2 ? t('enterAccountantID') : t('enterCaseID')}
                    value={accountantId}
                    className={Styles['style-input']}
                    onChange={handleInputChange(setAccountantId)}
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                      className: `custom-input-box-sizing-toggle ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                    }}
                  />
                </div>

                <div className={Styles['login-input-container']}>
                  <div className={Styles['login-input-label']}>
                    {t('enterPassword')}
                  </div>
                  <TextField
                    fullWidth
                    placeholder={t('enterPassword')}
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={handleInputChange(setPassword)}
                    className={`${Styles['style-input']} ${Styles['password-input']}`}
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                      className: `custom-input-box-sizing-toggle ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                      endAdornment: (
                        <InputAdornment style={{ boxSizing: 'border-box' }} position={direction === 'ltr' ? 'end' : 'start'}>
                          <IconButton
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge={direction === 'ltr' ? 'end' : 'start'}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className={Styles['forget-input-container']}>
                  <div className={Styles['register-client-input']} onClick={handleOpenModal}>
                    {t('NoBusinessAccountPrompt')}
                  </div>
                  <div className={Styles['forget-input']} onClick={handleSetForget}>
                    {t('Forget Password')}
                  </div>
                </div>
                <button type="submit" className={Styles['login-button']}>{t('login')}</button>
              </>
            }
          </form>
          </div>
        </div>
      </div>

      {
        mainPage &&
        <div
          className={Styles['login-whatsapp-fab']}
          onClick={handleContactUsPress}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') handleContactUsPress();
          }}
          aria-label="WhatsApp"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="42" viewBox="0 0 40 42" fill="none">
            <path d="M10.5722 35.4959L11.2261 35.8229C13.9509 37.4578 17.0027 38.2207 20.0545 38.2207C29.6458 38.2207 37.4932 30.3733 37.4932 20.782C37.4932 16.2044 35.6403 11.7357 32.3706 8.46594C29.1008 5.19618 24.7411 3.34332 20.0545 3.34332C10.4632 3.34332 2.61578 11.1907 2.72477 20.891C2.72477 24.1608 3.7057 27.3215 5.34057 30.0463L5.77654 30.7003L4.03267 37.1308L10.5722 35.4959Z" fill="#00E676" />
            <path d="M34.2234 6.72208C30.5177 2.90736 25.3951 0.836517 20.1635 0.836517C9.04632 0.836517 0.108992 9.88284 0.217984 20.891C0.217984 24.3788 1.19891 27.7575 2.83379 30.8093L0 41.1635L10.5722 38.4387C13.515 40.0736 16.7847 40.8365 20.0545 40.8365C31.0627 40.8365 40 31.7902 40 20.782C40 15.4414 37.9292 10.4278 34.2234 6.72208ZM20.1635 37.4578C17.2207 37.4578 14.2779 36.6948 11.7711 35.1689L11.1172 34.842L4.79564 36.4768L6.43052 30.2643L5.99455 29.6104C1.19891 21.8719 3.48774 11.6267 11.3351 6.83107C19.1826 2.03543 29.3188 4.32426 34.1144 12.1717C38.9101 20.0191 36.6213 30.1553 28.7738 34.951C26.267 36.5858 23.2153 37.4578 20.1635 37.4578ZM29.7548 25.3597L28.5559 24.8147C28.5559 24.8147 26.812 24.0518 25.7221 23.5068C25.6131 23.5068 25.5041 23.3978 25.3951 23.3978C25.0681 23.3978 24.8501 23.5068 24.6322 23.6158C24.6322 23.6158 24.5232 23.7248 22.9973 25.4687C22.8883 25.6867 22.6703 25.7956 22.4523 25.7956H22.3433C22.2343 25.7956 22.0163 25.6867 21.9074 25.5777L21.3624 25.3597C20.1635 24.8147 19.0736 24.1608 18.2016 23.2888C17.9837 23.0709 17.6567 22.8529 17.4387 22.6349C16.6758 21.8719 15.9128 21 15.3678 20.0191L15.2589 19.8011C15.1499 19.6921 15.1499 19.5831 15.0409 19.3651C15.0409 19.1471 15.0409 18.9292 15.1499 18.8202C15.1499 18.8202 15.5858 18.2752 15.9128 17.9482C16.1308 17.7303 16.2398 17.4033 16.4578 17.1853C16.6758 16.8583 16.7847 16.4223 16.6758 16.0954C16.5668 15.5504 15.2589 12.6076 14.9319 11.9537C14.7139 11.6267 14.4959 11.5177 14.1689 11.4087H13.842C13.624 11.4087 13.297 11.4087 12.97 11.4087C12.752 11.4087 12.5341 11.5177 12.3161 11.5177L12.2071 11.6267C11.9891 11.7357 11.7711 11.9537 11.5531 12.0627C11.3352 12.2807 11.2262 12.4986 11.0082 12.7166C10.2452 13.6976 9.80927 14.8965 9.80927 16.0954C9.80927 16.9673 10.0272 17.8392 10.3542 18.6022L10.4632 18.9292C11.4441 21 12.752 22.8529 14.4959 24.4877L14.9319 24.9237C15.2589 25.2507 15.5858 25.4687 15.8038 25.7956C18.0926 27.7575 20.7084 29.1744 23.6512 29.9373C23.9782 30.0463 24.4142 30.0463 24.7411 30.1553C25.0681 30.1553 25.5041 30.1553 25.8311 30.1553C26.376 30.1553 27.03 29.9373 27.4659 29.7194C27.7929 29.5014 28.0109 29.5014 28.2289 29.2834L28.4469 29.0654C28.6649 28.8474 28.8828 28.7384 29.1008 28.5204C29.3188 28.3025 29.5368 28.0845 29.6458 27.8665C29.8638 27.4305 29.9728 26.8856 30.0817 26.3406C30.0817 26.1226 30.0817 25.7956 30.0817 25.5777C30.0817 25.5777 29.9728 25.4687 29.7548 25.3597Z" fill="white" />
          </svg>
        </div>
      }

      <PasswordChanged
        visible={passwordDialogVisible}
        onClose={handleCloseDialog}
        t={t}
      />

      <ClientCreatedSuccessModal
        visible={showSuccessModal}
        onClose={closeCreatedSuccessModalModal}
        t={t}
      />

      <ClientRegisterModal
        open={addClientModalVisible}
        onClose={handleCloseModal}
        t={t}
        setShowSuccessModal={handleClientSuccess}
        direction={direction}
        toast={toast}
      />

      <ToastContainer />

      {loginSuccess && (
        <div className={Styles['login-success-overlay']} aria-hidden="true">
          <BrandXMark
            className={Styles['login-success-x']}
            armClassNames={{
              tl: `${Styles['login-success-x-arm']} ${Styles['login-success-x-arm-tl']}`,
              tr: `${Styles['login-success-x-arm']} ${Styles['login-success-x-arm-tr']}`,
              bl: `${Styles['login-success-x-arm']} ${Styles['login-success-x-arm-bl']}`,
              br: `${Styles['login-success-x-arm']} ${Styles['login-success-x-arm-br']}`,
            }}
          />
        </div>
      )}
    </div >
  );
};

export default Login;